<nb-accordion class="mb-4">
  <nb-accordion-item [expanded]="true">
    <nb-accordion-item-header>
      <div class="d-flex align-items-center">
        <i class="far fa-chart-line ms-2"></i>
        <span>گزارش‌گیری</span>
      </div>
    </nb-accordion-item-header>
    <nb-accordion-item-body>
      <div class="row mb-3">
        <div class="col-12 col-lg-6">
          <nb-card>
            <nb-card-header>فقط کاربران لیست</nb-card-header>
            <nb-card-body>
              <app-user-picker
                (add)="includedUsers = $event"
                (remove)="includedUsers = $event"
                [cacheKey]="'transaction_included_users'"
              ></app-user-picker>
            </nb-card-body>
          </nb-card>
        </div>
        <div class="col-12 col-lg-6">
          <div class="d-flex align-items-center gap-3 mb-2">
            ارز
            <nb-toggle (checkedChange)="$event ? currencySelector.selectAll() : currencySelector.deselectAll()">انتخاب
              همه
            </nb-toggle>
          </div>
          <app-select-currency
            [multiple]="true"
            #currencySelector
            (currency)="selectedCurrency = $event"
          ></app-select-currency>
          <app-validation-error [errors]="error" name="currency"></app-validation-error>
        </div>
      </div>
      <div class="d-flex justify-content-end">
        <button nbButton status="primary" (click)="report()">گزارش‌گیری</button>
      </div>
    </nb-accordion-item-body>
  </nb-accordion-item>
</nb-accordion>
<app-gift-card
  [RedeemedGiftCardUserId]="redeemedGiftCardUserIds"
  [currencyIds]="selectedCurrency"
></app-gift-card>
<app-crypt-deposit-history #CryptoDepositHistory [includedUsers]="includedUsers"
                           [selectedCurrency]="selectedCurrency"></app-crypt-deposit-history>
